import { render } from "./reading.mobile.vue?vue&type=template&id=714dd80e&scoped=true&ts=true"
import script from "./reading.mobile.vue?vue&type=script&scoped=true&lang=ts"
export * from "./reading.mobile.vue?vue&type=script&scoped=true&lang=ts"

import "./reading.mobile.vue?vue&type=style&index=0&id=714dd80e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714dd80e"]])

export default __exports__